import React from 'react';
import Chip, { ChipProps } from '@mui/material/Chip';
import makeStyles from '@mui/styles/makeStyles';
import { FONT_GSS_FUTURA_SEMI_BOLD } from '@monorepo/shared/src/themes/defaultTheme';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { IconButton, Theme } from '@mui/material';

const ReportFilterTag: React.FC<ChipProps> = ({
  label,
  icon,
  variant = 'outlined',
  color = 'primary',
  onDelete,
  ...rest
}) => {
  const classes = useStyles();

  return (
    <Chip
      tabIndex={-1}
      icon={icon}
      className={classes.chip}
      label={label}
      variant={variant}
      color={color}
      classes={{
        icon: classes.chipIcon,
      }}
      onDelete={onDelete}
      deleteIcon={
        <IconButton onClick={onDelete} aria-label="delete" size="small">
          <FontAwesomeIcon className={classes.chipIcon} icon={faTimes} />
        </IconButton>
      }
      {...rest}
    />
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  chip: {
    fontSize: theme.typography.pxToRem(14),
    lineHeight: theme.typography.pxToRem(20),
    height: theme.typography.pxToRem(24),
    fontFamily: FONT_GSS_FUTURA_SEMI_BOLD,
    backgroundColor: theme.palette.background.paper,
    paddingLeft: theme.typography.pxToRem(8),
  },
  chipIcon: {
    height: theme.typography.pxToRem(12),
  },
}));

export default ReportFilterTag;
